import { BoundSelectField, Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { Observer } from "mobx-react";
import { BidContractType, Maybe, SaveBidContractInput } from "src/generated/graphqlTypes";
import { BidPackageDetailActiveRequestFragment } from "src/routes/bids/BidPackageDetailPage.generated";
import { ObjectConfig, required, useFormState } from "src/utils/formState";

type SelectProrationModalProps = {
  requests: BidPackageDetailActiveRequestFragment[];
  bidPackageName: string;
  onContinue: (tradePartnerId: Maybe<string>, type: BidContractType) => void;
};

export function SelectProrationModal({ bidPackageName, requests, onContinue }: SelectProrationModalProps) {
  const { closeModal } = useModal();
  const tradePartners = requests.map((request) => request.tradePartner);
  const formState = useFormState({
    config: formConfig,
    init: {
      onlyOnce: true,
      input: { tradePartnerId: tradePartners[0].id, type: BidContractType.GroupedByPlanAndOption },
    },
  });

  return (
    <>
      <ModalHeader>Prorate {bidPackageName} Bid</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <BoundSelectField field={formState.tradePartnerId} label="Select Trade:" options={tradePartners} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="quaternary" onClick={() => closeModal()} />
        <Observer>
          {() => (
            <Button
              label="Continue"
              disabled={!formState.valid}
              onClick={() => onContinue(formState.tradePartnerId.value!, formState.type.value!)}
            />
          )}
        </Observer>
      </ModalFooter>
    </>
  );
}

type FormValues = Pick<SaveBidContractInput, "tradePartnerId" | "type">;

const formConfig: ObjectConfig<FormValues> = {
  tradePartnerId: { type: "value", rules: [required] },
  type: { type: "value", rules: [required] },
};
